// import React, { useState, useEffect } from "react";
// import { Truck, Users, Star, X, Check, Loader2 } from "lucide-react";
// import DistributorMasterLayout from "../../../layouts/distributor/DistributorMasterLayout";
// import "../../../assets/styles/distributor/DistributorSubscription.css";
// import axios from "axios";

// /* =============================================
//    CONFIG — update BASE_URL as per your backend
//    ============================================= */
// const BASE_URL = "https://your-api.com/api"; // <-- apna API base URL yahan lagao

// /* =============================================
//    API HELPERS
//    ============================================= */

// /** Admin ki taraf se sare available plans fetch karo */
// const fetchPlans = async () => {
//   const res = await fetch(`${BASE_URL}/admin/plans`);
//   if (!res.ok) throw new Error("Plans fetch karne mein error aaya");
//   return res.json(); // Array of plan objects expected
// };

// /** Distributor ki current subscription info fetch karo */
// const fetchDistributorSubscription = async (dis_id) => {
//   const res = await fetch(`${BASE_URL}/distributor/${dis_id}/subscription`);
//   if (!res.ok) throw new Error("Subscription info fetch karne mein error aaya");
//   return res.json();
// };

// /** Distributor ka plan update karo */
// const updateDistributorPlan = async (dis_id, plan_id) => {
//   const res = await fetch(`${BASE_URL}/distributor/update-plan`, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify({ dis_id, plan_id }),
//   });
//   if (!res.ok) throw new Error("Plan update karne mein error aaya");
//   return res.json();
// };

// /* =============================================
//    UPGRADE / DOWNGRADE MODAL
//    ============================================= */
// const UpgradeModal = ({ plan, currentPlan, onClose, onConfirm, loading }) => {
//   if (!plan) return null;

//   const isDowngrade =
//     currentPlan && plan.price_monthly < currentPlan.price_monthly;
//   const actionLabel = isDowngrade ? "Downgrade" : "Upgrade";

//   return (
//     <div className="distSub-overlay" onClick={onClose}>
//       <div className="distSub-modal" onClick={(e) => e.stopPropagation()}>
//         <button className="distSub-modal-close" onClick={onClose} disabled={loading}>
//           <X size={18} />
//         </button>

//         <div className="distSub-modal-header">
//           <h4>
//             {actionLabel} to {plan.name}
//           </h4>
//           <p>
//             {isDowngrade
//               ? "Aap premium features ka access kho denge aur customer limit reduce ho jayegi."
//               : `Aap ko ${
//                   plan.price_monthly > 0
//                     ? `PKR ${plan.price_monthly}/month`
//                     : "koi charge nahi"
//                 } next billing cycle se charge hoga.`}
//           </p>
//         </div>

//         <div className="distSub-upgrade-info">
//           <div className="distSub-upgrade-row">
//             <label>Current Plan:</label>
//             <strong>
//               {currentPlan
//                 ? `${currentPlan.name} — ${
//                     currentPlan.price_monthly > 0
//                       ? `PKR ${currentPlan.price_monthly}/mo`
//                       : "Free"
//                   }`
//                 : "—"}
//             </strong>
//           </div>
//           <div className="distSub-upgrade-row">
//             <label>New Plan:</label>
//             <strong>
//               {plan.name} —{" "}
//               {plan.price_monthly > 0 ? `PKR ${plan.price_monthly}/month` : "Free"}
//             </strong>
//           </div>
//         </div>

//         {/* Features of new plan */}
//         {plan.features && plan.features.length > 0 && (
//           <>
//             <div className="distSub-changes-title">Kya milega:</div>
//             <ul className="distSub-changes-list">
//               {plan.features.map((f, i) => (
//                 <li key={i}>{f}</li>
//               ))}
//             </ul>
//           </>
//         )}

//         <div className="distSub-modal-footer">
//           <button
//             className="distSub-btn-cancel"
//             onClick={onClose}
//             disabled={loading}
//           >
//             Cancel
//           </button>
//           <button
//             className="distSub-btn-confirm"
//             onClick={() => onConfirm(plan)}
//             disabled={loading}
//           >
//             {loading ? (
//               <>
//                 <Loader2 size={14} className="spin-icon" /> Processing...
//               </>
//             ) : (
//               `Confirm ${actionLabel}`
//             )}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

//  ─────────────────────────────────────────────────────────
//  PLAN FEATURES LIST
//  ─────────────────────────────────────────────────────────
// const PlanFeatures = ({ features }) => {
//   if (!features || features.length === 0) return null;
//   return (
//     <ul className="distSub-plan-features">
//       {features.map((f, i) => (
//         <li key={i}>
//           <Check size={13} />
//           <span>{f}</span>
//         </li>
//       ))}
//     </ul>
//   );
// };

//  ─────────────────────────────────────────────────────────
//  MAIN SUBSCRIPTION CONTENT
//  ─────────────────────────────────────────────────────────
// const SubscriptionContent = () => {
//   // ------ STATE ------
//   const [plans, setPlans] = useState([]);
//   const [subscription, setSubscription] = useState(null); // current distributor subscription
//   const [selectedPlan, setSelectedPlan] = useState(null); // plan clicked for modal
//   const [loadingPlans, setLoadingPlans] = useState(true);
//   const [loadingSub, setLoadingSub] = useState(true);
//   const [updating, setUpdating] = useState(false);
//   const [error, setError] = useState(null);
//   const [successMsg, setSuccessMsg] = useState(null);

//   // ------ dis_id — apne auth/context se lo ------
//   // Example: const { user } = useAuth(); const dis_id = user.dis_id;
//   const distributor_id = 1; // <-- REPLACE with actual dis_id from auth context

//   // ------ FETCH PLANS & SUBSCRIPTION ON MOUNT ------
//   useEffect(() => {
//     const loadData = async () => {
//       try {
//         setError(null);

//         const [plansData, subData] = await Promise.all([
//           fetchPlans(),
//           fetchDistributorSubscription(distributor_id),
//         ]);

//         setPlans(plansData);        // Admin se aye plans
//         setSubscription(subData);   // Distributor ki current subscription
//       } catch (err) {
//         setError(err.message || "Data load karne mein masla aaya");
//       } finally {
//         setLoadingPlans(false);
//         setLoadingSub(false);
//       }
//     };

//     loadData();
//   }, [distributor_id]);

//   // ------ CURRENT PLAN (plans list se match karke) ------
//   const currentPlan = plans.find(
//     (p) => p.id === subscription?.plan_id
//   ) || null;

//   // ------ HANDLE PLAN BUTTON CLICK ------
//   const handlePlanClick = (plan) => {
//     if (plan.id === subscription?.plan_id) return; // already current plan
//     setSelectedPlan(plan);
//     setSuccessMsg(null);
//   };

//   // ------ HANDLE CONFIRM UPDATE ------
//   const handleConfirmUpdate = async (plan) => {
//     setUpdating(true);
//     setError(null);
//     try {
//       updateDistributorPlan(distributor_id, plan.id); // dis_id + plan_id dono jayenge

//       // Local state update karo (API se re-fetch bhi kar sakte ho)
//       setSubscription((prev) => ({
//         ...prev,
//         plan_id: plan.id,
//         plan_name: plan.name,
//       }));

//       setSuccessMsg(`Plan successfully updated to "${plan.name}"!`);
//       setSelectedPlan(null);
//     } catch (err) {
//       setError(err.message || "Plan update karne mein masla aaya");
//     } finally {
//       setUpdating(false);
//     }
//   }

//   useEffect(() => {
//     fetchPlans();
//     fetchCurrentPlan();
//   }, [fetchPlans, fetchCurrentPlan]);

//   // ── Plan Selection ───────────────────────────────────
//   // const handlePlanClick = (plan) => {
//   //   if (plan.id === currentPlan?.id) return;
//   //   setSelectedPlan(plan);
//   // };

//   // ------ HELPER: Button label & type per plan ------
//   const getPlanBtn = (plan) => {
//     if (!subscription) return { label: "Select", type: "upgrade" };
//     if (plan.id === subscription.plan_id) return { label: "Current Plan", type: "current" };
//     if (currentPlan && plan.price_monthly < currentPlan.price_monthly)
//       return { label: "Downgrade", type: "downgrade" };
//     return { label: "Upgrade", type: "upgrade" };
//   };

//   // ------ LOADING STATE ------
//   // if (loadingPlans || loadingSub) {
//   //   return (
//   //     <div className="distSub-page">
//   //       <div className="distSub-loading">
//   //         <Loader2 size={32} className="spin-icon" />
//   //         <p>Loading subscription info...</p>
//   //       </div>
//   //     </div>
//   //   );
//   // }

//   // ------ CUSTOMERS USED (subscription data se) ------
//   const customersUsed = subscription?.customers_used ?? 0;
//   const customersMax = currentPlan?.customer_limit ?? "—";
//   const slotsRemaining =
//     customersMax !== "Unlimited" && customersMax !== "—"
//       ? customersMax - customersUsed
//       : "Unlimited";

//   return (
//     <div className="distSub-page">

//       {/* Toast */}
//       {toast && (
//         <Toast
//           message={toast.message}
//           type={toast.type}
//           onClose={() => setToast(null)}
//         />
//       )}

//       {/* Header */}
//       <div className="distSub-header">
//         <h2>My Subscription</h2>
//         <p>Manage your subscription plan and billing</p>
//       </div>

//       {/* Error / Success Messages */}
//       {error && (
//         <div className="distSub-alert distSub-alert-error">
//           <X size={14} /> {error}
//         </div>
//       )}
//       {successMsg && (
//         <div className="distSub-alert distSub-alert-success">
//           <Check size={14} /> {successMsg}
//         </div>
//       )}

//       {/* Current Plan Banner */}
//       {subscription && currentPlan && (
//         <div className="distSub-banner">
//           <div className="distSub-banner-top">
//             <div className="distSub-banner-left">
//               <div className="distSub-banner-icon">
//                 <Truck size={20} />
//               </div>
//               <div>
//                 <span className="distSub-banner-name">{currentPlan.name}</span>
//                 <span className="distSub-banner-renew">
//                   Your current active plan
//                   {subscription.renews_at
//                     ? ` • Renews ${new Date(subscription.renews_at).toLocaleDateString("en-US", {
//                         month: "short",
//                         day: "numeric",
//                         year: "numeric",
//                       })}`
//                     : ""}
//                 </span>
//               </div>
//             </div>
//             <div className="distSub-banner-right">
//               <span className="distSub-banner-price">
//                 {currentPlan.price_monthly > 0
//                   ? <>PKR {currentPlan.price_monthly.toLocaleString()}<span>/mo</span></>
//                   : "Free"}
//               </span>
//               <span className="distSub-active-badge">Active</span>
//             </div>
//           </div>

//           <div className="distSub-banner-bottom">
//             <div className="distSub-banner-meta">
//               <Users size={14} style={{ stroke: "var(--tertiary-color)", opacity: 0.6 }} />
//               <span>
//                 {customersUsed}/
//                 {customersMax === "Unlimited" ? "∞" : customersMax} Customers Used
//               </span>
//             </div>
//             <div className="distSub-banner-meta">
//               <Star size={14} style={{ stroke: "var(--tertiary-color)", opacity: 0.6 }} />
//               <span>
//                 {slotsRemaining === "Unlimited"
//                   ? "Unlimited slots"
//                   : `${slotsRemaining} slots remaining`}
//               </span>
//             </div>
//           </div>

//           {/* Usage Progress Bar */}
//           {currentPlan.customerlimit !== null && (
//             <div className="distSub-usage-bar-wrap">
//               <div className="distSub-usage-bar">
//                 <div
//                   className="distSub-usage-fill"
//                   style={{
//                     width: `${usagePercent}%`,
//                     background: usagePercent > 80 ? "#ef4444" : "#16a34a",
//                   }}
//                 />
//               </div>
//               <span className="distSub-usage-pct">{usagePercent}%</span>
//             </div>
//           )}
//         </div>
//       )}

//       {/* Plans Grid — admin se aye plans */}
//       <div className="distSub-plans-grid">
//         {plans.map((plan) => {
//           const { label, type } = getPlanBtn(plan);
//           const isCurrent = plan.id === subscription?.plan_id;

//           return (
//             <div
//               key={plan.id}
//               className={`distSub-plan-card ${isCurrent ? "is-current" : ""}`}
//             >
//               {isCurrent && (
//                 <div className="distSub-plan-tag">Current Plan</div>
//               )}

//               <div className="distSub-plan-card-title">{plan.name}</div>

//               <div className="distSub-plan-price-row">
//                 <strong>
//                   {plan.price_monthly > 0
//                     ? `PKR ${plan.price_monthly.toLocaleString()}`
//                     : "Free"}
//                 </strong>
//                 {plan.price_monthly > 0 && <span>/month</span>}
//               </div>

//               <span className="distSub-plan-limit">
//                 {plan.customer_limit === -1 || plan.customer_limit === null
//                   ? "Unlimited"
//                   : `Up to ${plan.customer_limit}`}
//               </span>

//               <ul className="distSub-features">
//                 {(plan.features || []).map((f, i) => (
//                   <li key={i}>
//                     <Check size={13} style={{ stroke: "#4caf50", flexShrink: 0 }} />
//                     {f}
//                   </li>
//                 ))}
//               </ul>

//               <button
//                 className={`distSub-plan-btn ${type}`}
//                 onClick={() => handlePlanClick(plan)}
//                 disabled={isCurrent || updating}
//               >
//                 {label}
//               </button>
//             </div>
//           );
//         })}
//       </div>

//       {/* Upgrade / Downgrade Modal */}
//       {selectedPlan && (
//         <UpgradeModal
//           plan={selectedPlan}
//           currentPlan={currentPlan}
//           onClose={() => !updating && setSelectedPlan(null)}
//           onConfirm={handleConfirmUpdate}
//           loading={updating}
//         />
//       )}
//     </div>
//   );
// };

// /* =============================================
//    EXPORT
//    ============================================= */
// const DistributorSubscription = () => (
//   <DistributorMasterLayout>
//     <SubscriptionContent />
//   </DistributorMasterLayout>
// );

// export default DistributorSubscription;

import React, { useContext, useEffect, useState } from "react";
import { Truck, Users, Star, X, Check } from "lucide-react";
import DistributorMasterLayout from "../../../layouts/distributor/DistributorMasterLayout";
import "../../../assets/styles/distributor/DistributorSubscription.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";

/* =============================================
    PLANS DATA — exactly matching reference
    ============================================= */
const PLANS = [
  {
    key: "free",
    name: "Free Plan",
    price: "Free",
    priceNum: null,
    period: "",
    limit: "Up to 10",
    isCurrent: false,
    features: [
      "10 customers max",
      "Basic dashboard",
      "QR code scanning",
      "Manual billing",
    ],
    btnLabel: "Downgrade",
    btnType: "downgrade",
    upgradeDetails: {
      title: "Downgrade to Free Plan",
      charge: null,
      isDowngrade: true,
      currentLabel: "Basic Plan — PKR 1,500/mo",
      newLabel: "Free Plan — Free",
      changes: [
        "Customer limit: Up to 10",
        "10 customers max",
        "Basic dashboard",
        "QR code scanning",
      ],
    },
  },
  {
    key: "basic",
    name: "Basic Plan",
    price: "PKR 1,500",
    priceNum: 1500,
    period: "/month",
    limit: "Up to 30",
    isCurrent: true,
    tag: "Current Plan",
    features: [
      "30 customers max",
      "Full dashboard",
      "Payment tracking",
      "Customer management",
      "Basic analytics",
    ],
    btnLabel: "Current Plan",
    btnType: "current",
    upgradeDetails: null,
  },
  {
    key: "standard",
    name: "Standard Plan",
    price: "PKR 2,500",
    priceNum: 2500,
    period: "/month",
    limit: "Up to 60",
    isCurrent: false,
    features: [
      "60 customers max",
      "Advanced analytics",
      "Priority support",
      "Area management",
      "Supplier tracking",
    ],
    btnLabel: "Upgrade",
    btnType: "upgrade",
    upgradeDetails: {
      title: "Upgrade to Standard Plan",
      charge: "PKR 2,500/month",
      currentLabel: "Basic Plan — PKR 1,500/mo",
      newLabel: "Standard Plan — PKR 2,500/month",
      changes: [
        "Customer limit: Up to 60",
        "60 customers max",
        "Advanced analytics",
        "Priority support",
      ],
    },
  },
  {
    key: "premium",
    name: "Premium Plan",
    price: "PKR 5,000",
    priceNum: 5000,
    period: "/month",
    limit: "Unlimited",
    isCurrent: false,
    features: [
      "Unlimited customers",
      "Full analytics suite",
      "Dedicated support",
      "Multi-area management",
      "Revenue reports",
      "API access",
    ],
    btnLabel: "Upgrade",
    btnType: "upgrade",
    upgradeDetails: {
      title: "Upgrade to Premium Plan",
      charge: "PKR 5,000/month",
      currentLabel: "Basic Plan — PKR 1,500/mo",
      newLabel: "Premium Plan — PKR 5,000/month",
      changes: [
        "Customer limit: Unlimited",
        "Full analytics suite",
        "Dedicated support",
        "Multi-area management",
        "Revenue reports",
        "API access",
      ],
    },
  },
];

const BILLING_HISTORY = [
  {
    id: "INV-2024-03",
    plan: "Basic Plan",
    amount: "PKR 1,500",
    date: "Mar 1, 2024",
    status: "Paid",
  },
  {
    id: "INV-2024-02",
    plan: "Basic Plan",
    amount: "PKR 1,500",
    date: "Feb 1, 2024",
    status: "Paid",
  },
  {
    id: "INV-2024-01",
    plan: "Basic Plan",
    amount: "PKR 1,500",
    date: "Jan 1, 2024",
    status: "Paid",
  },
];

/* =============================================
    UPGRADE MODAL
    ============================================= */
const UpgradeModal = ({ plan, onClose, onConfirm }) => {
  if (!plan || !plan.upgradeDetails) return null;
  const d = plan.upgradeDetails;
  const isDowngrade = !!d.isDowngrade;

  return (
    <div className="distSub-overlay" onClick={onClose}>
      <div className="distSub-modal" onClick={(e) => e.stopPropagation()}>
        <button className="distSub-modal-close" onClick={onClose}>
          <X size={18} />
        </button>

        <div className="distSub-modal-header">
          <h4>{d.title}</h4>
          <p>
            {isDowngrade
              ? "You will lose access to premium features. Your customer limit will be reduced to 10."
              : `You will be charged ${d.charge} starting from your next billing cycle.`}
          </p>
        </div>

        {/* Plan comparison */}
        <div className="distSub-upgrade-info">
          <div className="distSub-upgrade-row">
            <label>Current Plan:</label>
            <strong>{d.currentLabel}</strong>
          </div>
          <div className="distSub-upgrade-row">
            <label>New Plan:</label>
            <strong>{d.newLabel}</strong>
          </div>
        </div>

        {/* Changes */}
        <div className="distSub-changes-title">What changes:</div>
        <ul className="distSub-changes-list">
          {d.changes.map((c, i) => (
            <li key={i}>{c}</li>
          ))}
        </ul>

        <div className="distSub-modal-footer">
          <button className="distSub-btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button
            className="distSub-btn-confirm"
            onClick={() => {
              onConfirm(plan);
              onClose();
            }}
          >
            {isDowngrade ? "Confirm Downgrade" : "Confirm Upgrade"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* =============================================
    MAIN CONTENT
    ============================================= */
const SubscriptionContent = () => {
  const [upgradePlan, setUpgradePlan] = useState(null);
  const { baseUrl } = useContext(AppContext);

  const handleUpgradeClick = (plan) => {
    if (plan.btnType === "upgrade" || plan.btnType === "downgrade") {
      setUpgradePlan(plan);
    }
  };

  const handleConfirm = (plan) => {
    // In real app — call API here
    console.log("Upgrading to:", plan.name);
  };

  const getAllPlans = () => {
    axios
      .get(`${baseUrl}/distributor/plans/getAllPlans`)
      .then((res) => {
        console.log(res.data)
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    console.log("useEffect called");
    getAllPlans();
  }, []);

  return (
    <div className="distSub-page">
      {/* Header */}
      <div className="distSub-header">
        <h2>My Subscription</h2>
        <p>Manage your subscription plan and billing</p>
      </div>

      {/* Current Plan Banner — exact match to Image 1 */}
      <div className="distSub-banner">
        <div className="distSub-banner-top">
          <div className="distSub-banner-left">
            <div className="distSub-banner-icon">
              <Truck size={20} />
            </div>
            <div>
              <span className="distSub-banner-name">Basic Plan</span>
              <span className="distSub-banner-renew">
                Your current active plan • Renews Mar 30, 2024
              </span>
            </div>
          </div>
          <div className="distSub-banner-right">
            <span className="distSub-banner-price">
              PKR 1,500<span>/mo</span>
            </span>
            <span className="distSub-active-badge">Active</span>
          </div>
        </div>

        {/* Bottom meta row */}
        <div className="distSub-banner-bottom">
          <div className="distSub-banner-meta">
            <Users
              size={14}
              style={{ stroke: "var(--tertiary-color)", opacity: 0.6 }}
            />
            <span>18/30 Customers Used</span>
          </div>
          <div className="distSub-banner-meta">
            <Star
              size={14}
              style={{ stroke: "var(--tertiary-color)", opacity: 0.6 }}
            />
            <span>12 slots remaining</span>
          </div>
        </div>
      </div>

      {/* 4 Plan Cards */}
      <div className="distSub-plans-grid">
        {PLANS.map((plan) => (
          <div
            key={plan.key}
            className={`distSub-plan-card ${plan.isCurrent ? "is-current" : ""}`}
          >
            {/* Current Plan tag */}
            {plan.tag && <div className="distSub-plan-tag">{plan.tag}</div>}

            {/* Plan name */}
            <div className="distSub-plan-card-title">{plan.name}</div>

            {/* Price */}
            <div className="distSub-plan-price-row">
              <strong>{plan.price}</strong>
              {plan.period && <span>{plan.period}</span>}
            </div>

            {/* Limit */}
            <span className="distSub-plan-limit">{plan.limit}</span>

            {/* Features */}
            <ul className="distSub-features">
              {plan.features.map((f, i) => (
                <li key={i}>
                  <Check
                    size={13}
                    style={{ stroke: "#4caf50", flexShrink: 0 }}
                  />
                  {f}
                </li>
              ))}
            </ul>

            {/* Action Button */}
            <button
              className={`distSub-plan-btn ${plan.btnType}`}
              onClick={() => handleUpgradeClick(plan)}
              disabled={plan.btnType === "current"}
            >
              {plan.btnLabel}
            </button>
          </div>
        ))}
      </div>

      {/* Billing History */}
      {/* <div className="distSub-history-card">
         <div className="distSub-history-header">Billing History</div>
         <div style={{ overflowX: "auto" }}>
           <table className="distSub-history-table">
             <thead>
               <tr>
                 <th>Invoice ID</th>
                 <th>Plan</th>
                 <th>Amount</th>
                 <th>Date</th>
                 <th>Status</th>
               </tr>
             </thead>
             <tbody>
               {BILLING_HISTORY.map((row) => (
                 <tr key={row.id}>
                   <td style={{ fontWeight: 600, fontSize: "0.82rem", opacity: 0.6 }}>
                     {row.id}
                   </td>
                   <td>{row.plan}</td>
                   <td><strong style={{ fontWeight: 600 }}>{row.amount}</strong></td>
                   <td style={{ opacity: 0.65, fontSize: "0.82rem" }}>{row.date}</td>
                   <td>
                     <span className="distSub-paid-badge">{row.status}</span>
                   </td>
                 </tr>
               ))}
             </tbody>
           </table>
         </div>
       </div> */}

      {/* Upgrade Modal */}
      {upgradePlan && (
        <UpgradeModal
          plan={upgradePlan}
          onClose={() => setUpgradePlan(null)}
          onConfirm={handleConfirm}
        />
      )}
    </div>
  );
};

/* =============================================
    EXPORT — wrapped in DistributorMasterLayout
    ============================================= */
const DistributorSubscription = () => (
  <DistributorMasterLayout>
    <SubscriptionContent />
  </DistributorMasterLayout>
);

export default DistributorSubscription;
